import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SearchedCarModule } from '../car-listings/searched-cars/searched-car.module';
import { ResponsiveGridStyleModule } from '../cards/product/responsive-grid-style/responsive-grid-style.module';
import { StoreProductModule } from '../cards/product/store-product/store-products.module';
import { RecipeModule } from '../cards/recipe/recipe.module';
import { SearchComponent } from './search.component';
import { NewRecipeModule } from '../cards/new-recipe/new-recipe.module';

@NgModule({
  declarations: [SearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    RecipeModule,
    StoreProductModule,
    ResponsiveGridStyleModule,
    SearchedCarModule,
    NewRecipeModule,
  ],
  exports: [SearchComponent],
})
export class SearchModule {}
